import React from "react";
import { ModalConsumer } from "./ModalContext";

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, props, hideModal, nextLevel }) =>
      Component ? (
        <Component
          {...props}
          ariaHideApp={false}
          onRequestClose={hideModal}
          nextLevel={nextLevel}
        />
      ) : null
    }
  </ModalConsumer>
);

export default ModalRoot;



// WEBPACK FOOTER //
// ./src/components/ModalRoot.js